<template>
  <ReachInput
      ref="input"
      :formField="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly || !validatedField || validatedField.readOnly"
      :editor-mode="editorMode"
      :label="fieldConfig.labelOnly ? '\u00A0' : fieldConfig.fieldLabel"
      :hint="fieldConfig.labelOnly ? '' :fieldConfig.shortHelpText"
      :help-title="fieldConfig.labelOnly ? '' : fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.labelOnly ? '' :fieldConfig.htmlHelpText"
      :initialFocus="fieldConfig.autofocus"
  >
  </ReachInput>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import TrancheBookingDetails from "@/server/com/silkplm/model/plm/TrancheBookingDetails";
import TrancheBooking from "@/server/com/silkplm/model/plm/TrancheBooking";
export default {
  name: "ContainerNumberRenderer",
  components: {ReachInput},

  beforeDestroy() {
    EventBus.$off(Events.listMultiEdit);
  },
  async mounted() {
    this.parentForm.afterSave(async () => {
      await this.execute([this.parentForm.originalSource.id]);
    });
    this.$onEvent(Events.listMultiEdit, async (listOfIds) => {
      await this.execute(listOfIds);
    });
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },
    async execute(listOfIds) {
      let bookingDetailsFormClazz = await TrancheBookingDetails.getRemoteClass();
      let bookingFormClazz = await TrancheBooking.getRemoteClass();
      if (this.parentForm.formConfig.formClassLong === bookingDetailsFormClazz) {
        await Rpc.plm.services.TrancheBookingDetailsService.afterAssignContainerNumberToBookingDetailsCloneBooking(listOfIds).lock();
      }
      if (this.parentForm.formConfig.formClassLong === bookingFormClazz) {
        await Rpc.plm.services.TrancheBookingService.assignContainerNumberAfterChangeToBookingDetails(listOfIds).lock();
      }
      EventBus.$off(Events.listMultiEdit);
    },
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: TextFormFieldConfig, required: true},
    parentForm: {default: null},
    mode: {default: null}
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>